import { Page } from '@/core/architecture'

import { ThreadCreateTemplate } from './template'
import { useViewModel } from './viewModel'

/**
 * ThreadCreate Page
 * Implemented as a practical sample.
 */
export const ThreadCreate: Page = () => {
  const { state, actions } = useViewModel()

  return <ThreadCreateTemplate state={state} {...actions} />
}
